import { createSelector } from 'reselect'

/** A Redux selector to retrieve syndication
 * @param state - The Redux state
 * @param {Array} [] - The syndication to fetch
 */

const getSyndication = (state: any) => state.syndicationData

export const selectSyndicationData = createSelector(
  getSyndication,
  (data) => data ? data.syndicationData : {}
)

/** A Redux selector to retrieve syndication loading state
 * @param state - The Redux state
 * @param {Boolean} - Boolean value indicating whether Syndication is being loaded.
 */

export const selectSyndicationDataIsLoading = createSelector(
  getSyndication,
  (data) => data && data.status ? data.status.isLoading : false
)


const getApprovalInfo = (state: any) => state.syndicationData.approvalInfo

export const selectApprovalInfo = createSelector(
  getApprovalInfo,
  (data) => data ? data.authorisations : null
)

export const selectApproveSyndicationError = createSelector(
  getSyndication,
  (data) => data ? data.status.error : 'error'
)